<div *ngIf="gapi.user$ | async as user; else login">
  <nav [user]="gapi.user$"></nav>
</div>

<ng-template #login>
  <app-email-login></app-email-login>
</ng-template>
